function uuid() {
    return 'vvvvvvvv-vvvv-4vvv-yvvv-vvvvvvvvvvvv'.replace(/[vy]/g, function(c) {
        // eslint-disable-next-line no-mixed-operators
        var r = Math.random() * 16 | 0, v = c === 'v' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
export default uuid
